import React from "react";
import PropTypes from "prop-types";
import App from "components/App";
import { FormattedMessage } from "react-intl";
import "./styles.scss";

class RFELinkExpiredContent extends App {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        actionKey: PropTypes.string
      })
    })
  };

  render() {
    return (
      <React.Fragment>        
        <div className="container">          
          <div className="project-deleted__mainText">
            <p>
              <FormattedMessage
                id={"AuthorizeLink.components.RFELinkExpired.index.title is-4"}
              />
            </p>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default RFELinkExpiredContent;
